import React from 'react';
import { cn } from '@/lib/utils';

interface SheetLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const SheetLayout = React.forwardRef<HTMLDivElement, SheetLayoutProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div className="bg-neutral-100 dark:bg-neutral-950 min-h-screen font-sans antialiased selection:bg-neutral-900 selection:text-white py-8 px-4">
        <div
          ref={ref}
          className={cn(
            "max-w-5xl mx-auto bg-background border-2 border-neutral-950 dark:border-neutral-100 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,1)]",
            className
          )}
          {...props}
        >
          {children}
        </div>
      </div>
    );
  }
);
SheetLayout.displayName = "SheetLayout";
